"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InlineEditableCell = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.parse-float.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useDebounce = require("use-debounce");
var _Dropdown = require("../../../Forms/FormElements/Dropdown/Dropdown");
var _InputText = require("../../../Forms/FormElements/InputText");
var _DateRange = require("../../../Forms/FormElements/SpecialInputs/DateRange/DateRange");
var _InputTextarea = require("../../../Forms/FormElements/Textarea/InputTextarea");
var _OnOffSwitch = require("../../../Forms/FormElements/Checkbox/OnOffSwitch/OnOffSwitch");
var _InputCheckbox = require("../../../Forms/FormElements/Checkbox/InputCheckbox");
var _TableProps = require("../TableProps");
var _formFieldPropTypes = require("../../../../propTypes/formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const InlineEditableCell = props => {
  const {
    isEditable,
    onEdit,
    column,
    row,
    value,
    hookFormMethods
  } = props;
  const {
    id,
    inputType = 'text',
    options,
    multiSelect
  } = column;
  const {
    index
  } = row;
  const [fieldValue, setFieldValue] = (0, _react.useState)(value);
  const inputId = "editableTableCell_".concat(id, "_row_").concat(index);
  const fieldLabel = "Edit ".concat(id, " row ").concat(index);
  const [fieldProps] = (0, _react.useState)({
    name: inputId || fieldLabel,
    hideLabel: true,
    label: fieldLabel,
    fieldFormContext: hookFormMethods
  });
  const DebouncedChange = (0, _useDebounce.useDebouncedCallback)(newValue => {
    onEdit({
      index,
      id,
      newValue
    });
  }, 500);
  const HandleChange = (e, parsedValue) => {
    const isEvent = e.target;
    const fieldValue = isEvent ? e.target.value : e;
    const isTextInput = isEvent && e.target.tagName === 'input' && (e.target.type === 'text' || e.target.type === 'number');

    // If a pre-parsed value has been sent use it otherwise check if it should be a number
    const newValue = parsedValue || (inputType === 'number' ? parseFloat(fieldValue) : fieldValue);
    if (isTextInput) {
      DebouncedChange(newValue);
    } else {
      onEdit({
        index,
        id,
        newValue
      });
    }
  };
  const HandleCheckboxChange = newValue => {
    setFieldValue(newValue);
    onEdit({
      index,
      id,
      newValue
    });
  };
  const HandleDropdownChange = (e, parsedValue, selectedIndex, selectedOptions) => {
    const selectedValues = [...selectedOptions].map(selectedOption => JSON.parse(selectedOption.dataset.option));
    const newValue = multiSelect ? selectedValues : selectedValues[0];
    setFieldValue(newValue);
    onEdit({
      index,
      id,
      newValue
    });
  };
  if (!isEditable) {
    return "".concat(value);
  }
  if (Object.keys(fieldProps).length === 0) {
    return null;
  }
  switch (inputType) {
    case 'onOffSwitch':
      return /*#__PURE__*/_react.default.createElement(_OnOffSwitch.OnOffSwitch, _extends({}, fieldProps, {
        onChange: HandleChange,
        label: fieldLabel,
        id: inputId,
        checked: fieldValue
      }));
    case 'checkbox':
      return /*#__PURE__*/_react.default.createElement(_InputCheckbox.InputCheckbox, _extends({}, fieldProps, {
        customChangeHandler: HandleCheckboxChange,
        label: fieldLabel,
        hideLabel: true,
        id: inputId,
        defaultChecked: fieldValue
      }));
    case 'select':
      return /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, _extends({}, fieldProps, {
        defaultValue: fieldValue,
        options: options,
        customChangeHandler: HandleDropdownChange
      }));
    case 'textarea':
      return /*#__PURE__*/_react.default.createElement(_InputTextarea.InputTextarea, _extends({
        inputType: "textarea"
      }, fieldProps, {
        defaultValue: fieldValue,
        customChangeHandler: HandleChange
      }));
    case 'dateRange':
      return /*#__PURE__*/_react.default.createElement(_DateRange.DateRange, _extends({}, fieldProps, {
        defaultValue: fieldValue,
        customChangeHandler: HandleChange
      }));
    case 'number':
      return /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
        inputType: "number"
      }, fieldProps, {
        defaultValue: fieldValue,
        customChangeHandler: HandleChange
      }));
    default:
      return /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({}, fieldProps, {
        defaultValue: fieldValue,
        customChangeHandler: HandleChange
      }));
  }
};
exports.InlineEditableCell = InlineEditableCell;
InlineEditableCell.propTypes = {
  isEditable: _propTypes.default.bool,
  value: _propTypes.default.oneOfType(_formFieldPropTypes.ValuePropTypes),
  column: _propTypes.default.shape(_TableProps.TableColumnProps),
  row: _propTypes.default.shape(_TableProps.TableRowProps),
  onEdit: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  hookFormMethods: _propTypes.default.any
};
var _default = exports.default = {
  InlineEditableCell
};